import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Weforsys-table",
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columnData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 序号 默认有
    hasNO: {
      type: Boolean,
      default: true
    },
    // 多选框 默认无
    hasC: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number
    },
    pageSize: {
      type: Number
    },
    height: {
      default: "100%"
    }
  },
  watch: {
    data: {
      handler: function handler(val) {
        if (!val) return;
        this.doLayout();
      },
      deep: true
    },
    columnData: {
      handler: function handler(val) {
        if (!val) return;
        this.doLayout();
      },
      deep: true
    }
  },
  activated: function activated() {
    var _this = this;
    // 解决缓存出现的表格错位问题
    this.$nextTick(function () {
      _this.$refs.WeforsysTable.doLayout();
    });
  },
  methods: {
    indexMethod: function indexMethod(index) {
      if (this.currentPage != undefined && this.pageSize != undefined) {
        return (this.currentPage - 1) * this.pageSize + index + 1;
      } else {
        return index + 1;
      }
    },
    doLayout: function doLayout() {
      var _this2 = this;
      setTimeout(function () {
        _this2.$nextTick(function () {
          _this2.$refs.WeforsysTable.doLayout();
        });
      }, 50);
    }
  }
};